import { Col, Input, Label, Row } from "reactstrap";
import React from "react";

export function TabStepBBusinessContactInformation({
  customerDetails,
  setCustomerDetails,
  handleRemoveEmailRow,
  handleAddEmailRow,
  handleRemovePhoneRow,
  handleAddPhoneRow,
  toggleVerticalTab,
  activeVerticalTab,
}) {
  const field = (key) => (e) =>
    setCustomerDetails((prev) => ({ ...prev, [key]: e.target.value }));

  return (
    <>
      <div>
        <h5>Contact Information</h5>
      </div>

      <Row className="g-3">
        {/* Primary flat contact fields */}
        <Col lg={6}>
          <Label className="form-label">Primary Phone</Label>
          <Input
            type="text"
            className="form-control"
            placeholder="Contact telephone number"
            value={customerDetails?.ContactTelephoneNumber ?? ""}
            onChange={field("ContactTelephoneNumber")}
          />
        </Col>
        <Col lg={6}>
          <Label className="form-label">Primary Email</Label>
          <Input
            type="email"
            className="form-control"
            placeholder="Contact email address"
            value={customerDetails?.ContactEmailAddress ?? ""}
            onChange={field("ContactEmailAddress")}
          />
        </Col>

        {/* Additional email/phone lists */}
        <Col lg={6}>
          <div>
            <span className={"h6"}>Additional Email Addresses</span>
          </div>
          <div className={"d-flex flex-column w-100"}>
            {customerDetails.contactemailaddress_list?.map((email, index) => (
              <div key={email.Id} className={"d-flex p-2"}>
                <input
                  type="text"
                  className={"form-control"}
                  value={email.EmailAddress}
                  onChange={(e) => {
                    setCustomerDetails((prevState) => {
                      const newState = { ...prevState };
                      newState.contactemailaddress_list[index].EmailAddress = e.target.value;
                      return newState;
                    });
                  }}
                />
                {customerDetails.contactemailaddress_list.length > 1 && (
                  <span
                    onClick={() => handleRemoveEmailRow(email.Id)}
                    className={"ms-1 btn btn-soft-danger"}
                  >
                    <i className={"fa-solid fa-minus"}></i>
                  </span>
                )}
              </div>
            ))}
            <div>
              <span
                onClick={handleAddEmailRow}
                className={"ms-1 btn btn-soft-success"}
              >
                <i className={"fa-solid fa-plus"}></i> Add Email
              </span>
            </div>
          </div>
        </Col>
        <Col lg={6}>
          <div>
            <span className={"h6"}>Additional Phone Numbers</span>
          </div>
          <div className={"d-flex flex-column w-100"}>
            {customerDetails.contacttelephonenumber_list?.map((phone, index) => (
              <div key={phone.Id} className={"d-flex p-2"}>
                <input
                  type="text"
                  className={"form-control"}
                  value={phone.TelephoneNumber}
                  onChange={(e) => {
                    setCustomerDetails((prevState) => {
                      const newState = { ...prevState };
                      newState.contacttelephonenumber_list[index].TelephoneNumber = e.target.value;
                      return newState;
                    });
                  }}
                />
                {customerDetails.contacttelephonenumber_list.length > 1 && (
                  <span
                    onClick={() => handleRemovePhoneRow(phone.Id)}
                    className={"ms-1 btn btn-soft-danger"}
                  >
                    <i className={"fa-solid fa-minus"}></i>
                  </span>
                )}
              </div>
            ))}
            <div>
              <span
                onClick={handleAddPhoneRow}
                className={"ms-1 btn btn-soft-success"}
              >
                <i className={"fa-solid fa-plus"}></i> Add Phone Nr.
              </span>
            </div>
          </div>
        </Col>

        {/* URLs */}
        <Col lg={12}>
          <hr className="my-2 text-muted" />
          <h6 className="fw-bold mb-3">Website & Review Links</h6>
        </Col>
        <Col lg={6}>
          <Label className="form-label">Website Homepage</Label>
          <Input
            type="url"
            className="form-control"
            placeholder="https://www.example.com"
            value={customerDetails?.UrlWebsiteHomepage ?? ""}
            onChange={field("UrlWebsiteHomepage")}
          />
        </Col>
        <Col lg={6}>
          <Label className="form-label">Book a Table URL</Label>
          <Input
            type="url"
            className="form-control"
            placeholder="https://..."
            value={customerDetails?.UrlWebsiteBookATable ?? ""}
            onChange={field("UrlWebsiteBookATable")}
          />
        </Col>
        <Col lg={6}>
          <Label className="form-label">Leave a Review URL</Label>
          <Input
            type="url"
            className="form-control"
            placeholder="https://..."
            value={customerDetails?.UrlLeaveAReview ?? ""}
            onChange={field("UrlLeaveAReview")}
          />
        </Col>
        <Col lg={6}>
          <Label className="form-label">Leave Feedback URL</Label>
          <Input
            type="url"
            className="form-control"
            placeholder="https://..."
            value={customerDetails?.UrlLeaveFeedback ?? ""}
            onChange={field("UrlLeaveFeedback")}
          />
        </Col>

        {/* Notes */}
        <Col lg={12}>
          <hr className="my-2 text-muted" />
          <Label className="form-label">Notes</Label>
          <Input
            type="textarea"
            className="form-control"
            rows={3}
            placeholder="Any additional notes about this location…"
            value={customerDetails?.Notes ?? ""}
            onChange={field("Notes")}
          />
        </Col>
      </Row>

      <hr className="my-4 text-muted" />

      <div className="d-flex align-items-start gap-3 mt-4">
        <button
          type="button"
          className="btn btn-light btn-label previestab"
          onClick={() => toggleVerticalTab(activeVerticalTab - 1)}
        >
          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
          Name & Address
        </button>
        <button
          type="button"
          className="btn btn-success btn-label right ms-auto nexttab"
          onClick={() => toggleVerticalTab(activeVerticalTab + 1)}
        >
          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
          Branding
        </button>
      </div>
    </>
  );
}
